<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex flex-col sm:flex-row justify-between my-3 gap-3">
  <h2>Rent Bookings</h2>
  <div class="flex gap-2">
    <button nz-button nzType="default" class="outline-button" (click)="openMultiplePagingBoard()">Create Paging Boards</button>
    <button nz-button nzType="default" class="outline-button" (click)="openPaymentCSVDateFilter()">Payment List Download</button>
    <button *appHasAnyPrivilege="'RENT_BOOKING_CREATE'" nz-button nzType="primary"
            routerLink="/admin/booking-rent/add-edit">Add New Rent Booking
    </button>
  </div>
</div>

<section>

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="!loading ? 'block' : 'hidden'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center md:items-end gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton" style="width: auto">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input
                         placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" (click)="search()" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>

                <div class="flex xl:w-auto  flex-col lg:flex-row lg:items-center">
                  <div>
                    <nz-form-label>Filter By Status</nz-form-label>
                  </div>

                  <div class="w-full">
                    <nz-select
                      [(ngModel)]="statusFilter"
                      (ngModelChange)="search()"
                      (close)="resetSearch('status')"
                      [nzAllowClear]="true"
                      class="w-full"
                      nzPlaceHolder="Select Status">
                      <nz-option nzLabel="Reservation" nzValue="RESERVATION"></nz-option>
                      <nz-option nzLabel="On Rent" nzValue="ON_RENT"></nz-option>
                      <nz-option nzLabel="Completed" nzValue="COMPLETED"></nz-option>
                      <nz-option nzLabel="Cancelled" nzValue="CANCELLED"></nz-option>
                    </nz-select>
                  </div>
                </div>
                <div>
                  <nz-divider
                    [nzType]="'vertical'"
                    class="hidden lg:block"
                  ></nz-divider>
                </div>

                <nz-range-picker [(ngModel)]="dateRanges"
                                 (close)="resetSearch('date')"
                                 (ngModelChange)="onChangeDateFilter($event)"></nz-range-picker>
                <!--                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>-->
                <!--                <div class="flex gap-2">-->
                <!--                  <button nz-button nzType="default" class="rounded-full">Arrival</button>-->
                <!--                  <button nz-button nzType="default" class="rounded-full">Departure</button>-->
                <!--                </div>-->
              </div>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch('all')">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="!loading ? 'block' : 'hidden'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="bookingData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto',y: '550px'}"
            nzOuterBordered 
          >
            <thead>
            <tr>
              <th rowspan="2" style="min-width:120px;">SR Rent ID</th>
              <th rowspan="2" style="min-width:230px;">Agent Booking Reference</th>
              <th rowspan="2" style="min-width:150px;">Agent</th>
              <th rowspan="2" style="min-width:100px;">Country</th> 
              <th rowspan="2" style="min-width:150px;">Pax Count</th>
              <th rowspan="2" style="min-width:150px;">Status</th>
              <th rowspan="2" style="min-width:150px;">Customer Name</th>
              <th rowspan="2" style="min-width:220px;">Local Permit Requirements</th>
              <th rowspan="2" style="min-width:150px;">No of Days</th>
              <th rowspan="2" style="min-width:220px;">Arrival Date and Time</th>
              <th rowspan="2" style="min-width:220px;">Departure Date and Time</th>
              <th rowspan="2" style="min-width:150px;">Vehicle Type</th>
              <th rowspan="2" style="min-width:220px;">Allocated Vehicle Reg No</th>
              <th colSpan="2" >Arrival and Departure Handler</th>
              <th rowspan="2" style="min-width:150px;">Flight Number</th>
              <th rowspan="2" style="min-width:150px;">
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span></th>
              <th rowspan="2" style="min-width:150px;" *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW,RENT_BOOKING_UPDATE'">Action</th>
            </tr>

            <tr>
              <th style="min-width:175px;">Arrival</th>
              <th style="min-width:175px;">Departure</th>
            </tr>

            </thead>
            <tbody>

            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td style="min-width:120px;">
                <a *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW'" class="clickable-text"
                   (click)="navigateTo('single', data?._id)">{{ data?.refNo }}</a>
                <span *ngIf="!hasPermission('RENT_BOOKING_SINGLE_VIEW')">{{ data?.refNo }}</span>
              </td>
              <td style="min-width:230px;">{{ data?.bookingDetails?.bookingReferenceNo ? data?.bookingDetails?.bookingReferenceNo : '-' }}</td>
              <td style="min-width:150px;">{{ data?.bookingDetails?.agent ? data?.bookingDetails?.agent?.name : '-' }}</td>
              <td style="min-width:100px;">{{ data?.customerDetails?.customer ? data?.customerDetails?.customer?.renterDetails?.homeCountry : '-' }}</td>
              <td style="min-width:150px;">{{ data?.tourDetails?.numberOfPassengers ? data?.tourDetails?.numberOfPassengers : '-' }}</td>
              <td style="min-width:150px;">
                <nz-tag *ngIf="data?.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                        class="rounded-full"
                >Completed
                </nz-tag
                >
                <nz-tag
                  *ngIf="data?.status === 'CANCELLED'" class="rounded-full" [nzColor]="'#F3454C'"
                >Cancelled
                </nz-tag>
                <nz-tag
                  *ngIf="data?.status === 'RESERVATION'"
                  [nzColor]="'#FF8C00'" class="rounded-full"
                >Reservation
                </nz-tag>
                <nz-tag
                  *ngIf="data?.status === 'ON_RENT'"
                  [nzColor]="'#4655f5'" class="rounded-full"
                >On Rent
                </nz-tag>
              </td>
              <td style="min-width:150px; white-space: nowrap">{{ data?.customerDetails?.customer ? data?.customerDetails?.customer?.renterDetails?.fullName : '-' }}</td>
              <td style="min-width:220px;">{{ data?.customerDetails?.localPermitRequirements ? 'Yes' : 'No' }}</td>
              <td style="min-width:150px;">{{ data?.tourDetails?.numberOfDays ? data?.tourDetails?.numberOfDays : '-' }}</td>
              <td style="min-width:220px; white-space: nowrap">{{ data?.tourDetails?.arrivalInformation?.arrivalDateAndTime | date: 'dd-MM-y | hh:mm:a' }}</td>
              <td style="min-width:220px; white-space: nowrap">{{ data?.tourDetails?.departureInformation?.departureDateAndTime | date: 'dd-MM-y | hh:mm:a' }}</td>
              <td style="min-width:150px;">{{ getVehicleCategory(data) }}</td>
              <td style="min-width:220px;">{{ getVehicleRegisterNo(data) }}</td>
              <td style="min-width:175px; white-space: nowrap">{{ data?.arrivalHandlerId ? data?.arrivalHandlerName : '-' }}</td>
              <td style="min-width:175px; white-space: nowrap">{{ data?.departureHandlerId ? data?.departureHandlerName : '-' }}</td>
              <td style="min-width:150px;">{{ data?.tourDetails?.arrivalInformation?.arrivalFlightNo ? data?.tourDetails?.arrivalInformation?.arrivalFlightNo : '-' }}</td>
              <td style="min-width:150px;">{{ data?.createdAt | date: 'dd-MM-y' }}</td>
              <td style="min-width:150px;" *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW,RENT_BOOKING_UPDATE'">
                <button *appHasAnyPrivilege="'RENT_BOOKING_UPDATE'" class="mr-3" nz-button  [class.outline-button]="data?.status !== 'COMPLETED'"
                        nzType="default" (click)="navigateTo('edit', data?._id)" [disabled]="data?.status === 'COMPLETED'">Edit
                </button>
                <button *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW,RENT_BOOKING_UPDATE'"
                        class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter"
                >
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'RENT_BOOKING_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button
                        (click)="navigateTo('single', data?._id)">View
                    </li>
                    <!--                    <li *appHasAnyPrivilege="'RENT_BOOKING_CHANGE_STATUS'" nz-submenu nzTitle="Change Status">-->
                    <li *appHasAnyPrivilege="'RENT_BOOKING_CHANGE_STATUS'">
                      <div *ngIf="data?.status !== 'COMPLETED'" nz-submenu nzTitle="Change Status">
                        <ul>
                          <li nz-menu-item nz-popconfirm *ngIf="( data?.status === 'CANCELLED')"
                              nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
                              [nzOkText]="'Yes'" [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="handleOkSelectStatus('RESERVATION', data)">Reservation
                          </li>
                          <li nz-menu-item nz-popconfirm *ngIf="(data?.status === 'RESERVATION')"
                              nzPopconfirmTitle="Are you sure you want change the status to On Rent?"
                              [nzOkText]="'Yes'" [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="handleOkSelectStatus('ON_RENT', data)">On Rent
                          </li>
                          <li nz-menu-item nz-popconfirm *ngIf="( data?.status === 'ON_RENT')"
                              nzPopconfirmTitle="Are you sure there are no damages in the vehicle?"
                              [nzOkText]="'Yes'" [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus('COMPLETED', data)"
                              (nzOnConfirm)="handleOkSelectStatus('COMPLETED', data)">Completed
                          </li>
                          <li nz-menu-item nz-popconfirm
                              *ngIf="(data?.status === 'RESERVATION' || data?.status === 'ON_RENT')"
                              nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
                              [nzOkText]="'Yes'" [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="handleOkSelectStatus('CANCELLED', data)">Cancelled
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>

</section>

<app-multiple-paging-board-popup [isVisible]="openMultiplePagingBoardPopup" [tourType]="'RENT'" (multiplePagingBoardOnChange)="onGetMultiplePagingBoardChange($event)"></app-multiple-paging-board-popup>

<nz-modal
  [(nzVisible)]="isVisibleFuelAndMileageUpdate"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
>
  <ng-template
    #modalTitle>{{ changingStatus === 'CANCELLED' ? 'Reason for Cancellation' : 'Current Fuel and Mileage Update' }}
  </ng-template>

  <ng-template #modalContent>
    <div *ngIf="changingStatus === 'ON_RENT' || changingStatus === 'COMPLETED'" class="flex flex-col gap-4">
      <p class="font-bold">{{ changingStatus === 'ON_RENT' ? 'Start' : 'End' }} Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>
      <p class="font-bold">{{ changingStatus === 'ON_RENT' ? 'Start' : 'End' }} Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select class="w-full" [(ngModel)]="cancelReason" nzPlaceHolder="Select Preference"
                 nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate">
        <nz-option *ngFor="let item of cancelReasonOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement/>
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelUpdateFuelAndMileage()">Cancel</button>
    <button *ngIf="!(changingStatus === 'CANCELLED')" nz-button nzType="primary"
            [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkUpdateFuelAndMileage()" [nzLoading]="isLoading">Save
    </button>
    <button *ngIf="changingStatus === 'CANCELLED'" nz-button nzType="primary" [disabled]="(cancelReason === null)"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkCancelledStatus()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="openPaymentListDatePicker"
  [nzTitle]="modalPaymentDateTitle"
  [nzContent]="modalPaymentDateContent"
  [nzFooter]="modalPaymentDateFooter"
  (nzOnCancel)="openPaymentListDatePicker = false"
>
  <ng-template #modalPaymentDateTitle>
    <div class="h-3"></div>
  </ng-template>
  <ng-template #modalPaymentDateContent>
    <nz-range-picker class="w-full" [(ngModel)]="paymentDateRanges" (ngModelChange)="onChangePaymentListDatePicker($event)"></nz-range-picker>
    <span *ngIf="paymentDataLoading" class="text-primary">Loading...</span>
  </ng-template>
  <ng-template #modalPaymentDateFooter>

  </ng-template>

</nz-modal>
